import MasterLayout from 'components/layouts/MasterLayout'
import { LoadingBarProcess } from 'components/loadingProcess/LoadingBarProcess'
import React from 'react'
import { Route, Routes } from 'react-router-dom'

const GenealogyPage = React.lazy(() => import('pages/genealogy/GenealogyPage'))

const GenealogyRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MasterLayout />}>
        <Route
          index
          element={
            <React.Suspense fallback={<LoadingBarProcess />}>
              {/* <RequireAuth> */}
                <GenealogyPage />
              {/* </RequireAuth> */}
            </React.Suspense>
          }
        />
      </Route>
    </Routes>
  )
}

export default GenealogyRoutes